var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',{attrs:{"exclude":_vm.excludename}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }